<template>
  <el-card class="relative h-full overflow-y-auto">
    <el-page-header @back="goback"></el-page-header>
    <div class="h-full mt-20px">
      <div>
        <span class="border-l-2 border-blue-500 pl-10px text-16px mb-20px">{{
          $t('在线培训')
        }}</span>
      </div>
      <div class="flex pl-20px mt-20px">
        <div class="w-800px mr-30px">
          <div v-show="!isVideoShow">
            <div class="h-500px w-full overflow-y-auto">
              <div>
                <div class="title mb-20px">
                  {{ problemIndex + 1 }}、【{{ questionListMap(problem.questionType) }}】&nbsp;{{
                    problem.topic
                  }}
                </div>
                <div class="content">
                  <el-row class="tl" v-if="[0, 1, 2].includes(problem.questionType)">
                    <el-col
                      v-for="(item, index) in JSON.parse(problem.content)"
                      :key="index"
                      class="h-36px border mb-10px leading-36px pl-10px"
                      :class="item.checked ? 'border-hex-0099ff border-2px' : ''"
                    >
                      <el-checkbox :value="item.checked"
                        >{{ words[index] }}、{{ item.content }}</el-checkbox
                      >
                    </el-col>
                  </el-row>
                  <el-row class="tl p-l-20" v-if="problem.questionType === 2">
                    <el-col v-for="(item, index) in problem.titleList" :key="index">
                      <el-checkbox
                        v-model="problem.choice"
                        disabled
                        :name="`${index}`"
                        :label="item"
                      >
                      </el-checkbox>
                    </el-col>
                  </el-row>
                  <el-row class="tl p-l-20" v-if="[3, 4].includes(problem.questionType)">
                    <el-col class="flex">
                      <span class="whitespace-nowrap">参考答案：</span
                      ><span v-html="problem.answer"></span>
                    </el-col>
                  </el-row>
                </div>
                <div class="analyze mt-20px flex">
                  <div class="whitespace-nowrap">答案解析：</div>
                  <div class=" leading-22px ">
                    <span v-html="problem.analysis"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center">
              <el-button
                type="primary"
                :loading="videoLoading"
                @click="isVideoShow = true"
                class="mr-30px"
                >返回上级</el-button
              >
              <el-button type="primary" :loading="videoLoading" @click="goNextProblem"
                >下一题（课程）</el-button
              >
            </div>
          </div>
          <div v-show="isVideoShow" class="w-800px">
            <video-player
              class="video-player vjs-custom-skin v-player w-800px h-500px"
              :playsinline="true"
              ref="videoRef"
              @pause="pauseHandle($event)"
              @loadeddata="loadHandle($event)"
              @ended="endHandle($event)"
              :options="options"
              @timeupdate="timeHandle"
            ></video-player>
            <div class="text-center">
              <el-button
                type="primary"
                @click="getPreCourse"
                class="mr-30px"
                :disabled="!currentCourse.checkPrevMaterial && !currentCourse.checkPrevCourseware"
                :loading="videoLoading"
                >上一课程</el-button
              >
              <el-button
                type="primary"
                @click="getNextCourse"
                :loading="videoLoading"
                :disabled="
                  !currentCourse.hasNext || currentCourse.studyTimes !== currentCourse.times
                "
                >下一课程</el-button
              >
            </div>
          </div>
        </div>

        <div class="flex-1 h-500px">
          <div class="mb-10px">
            <span class="mr-10px"
              >课程学习进度：{{
                (sourceData.finishCoursewares || '--') +
                  ' / ' +
                  (sourceData.coursewareCount || '--')
              }}</span
            >
            <span class="mr-10px"
              >学时完成进度：{{
                getPercent(sourceData.finishTimes, sourceData.coursewareTimes)
              }}</span
            >
            <span
              >学分完成进度：{{
                (sourceData.finishCredits || '--') + ' / ' + (sourceData.coursewareCredits || '--')
              }}</span
            >
          </div>
          <div>
            <el-table
              :data="tableList"
              border
              class="w-full"
              height="470px"
              stripe
              @row-click="changeCourse"
              :cell-style="getCurrentTr"
            >
              <el-table-column label="课件" prop="name" show-overflow-tooltip></el-table-column>
              <el-table-column label="是否必修" prop="isCompulsory" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.isCompulsory ? '是' : '否' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="节点"
                width="60px"
                prop="nodes"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column label="学习开始时间" prop="studyTimeStart" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.studyTimeStart | showTime('time') }}</span>
                </template>
              </el-table-column>
              <el-table-column label="学习结束时间" prop="studyTimeEnd" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.studyTimeEnd | showTime('time') }}</span>
                </template>
              </el-table-column>
              <el-table-column label="培训进度" prop="statusName" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div
                    class="status-text"
                    :style="{
                      backgroundColor: ['#a4adb3', '#0099ff', '#37c404'][scope.row.status],
                    }"
                  >
                    {{ scope.row.statusName }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { TrainingTaskApi } from '@wiz-api/training-management'
import { FileApi } from '@wiz-api/file-management'
import { videoPlayer } from 'vue-video-player'
import dayjs from 'dayjs'
import { wordsList } from '@/components/safety/enumField/enumTagType'
import { typeList, formatSeconds } from '../EnumField'

const trainingTaskApi = new TrainingTaskApi()
const fileApi = new FileApi()
export default {
  name: 'conduct-training',
  components: { videoPlayer },
  data() {
    return {
      words: wordsList,
      // 题目类型
      questionList: typeList,
      tableList: [],
      problem: {},
      problemIndex: 0,
      sourceData: {},
      isVideoShow: true,
      currentIndex: 0,
      fileId: [],
      options: {
        autoplay: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        loop: false,
        sources: [],
        poster: null,
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间
        },
      },
      currentCourse: {},
      videoLastTime: 0,
      saveTimer: 0,
      IsDoneCompelete: false,
      currentProblemList: [],
      videoLoading: false,
      qualified: false, // 是否达到培训要求
    }
  },
  filters: {
    showTime: (val, type) => {
      let result = val
      if (type === 'time' && val) {
        result = dayjs(result).format('YYYY-MM-DD HH:mm:ss')
      }
      return result
    },
  },
  computed: {
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/`
    },
  },
  methods: {
    // 正在学习高亮
    getCurrentTr({ row }) {
      if (row.id === this.currentCourse.trainingPersonCoursewareId) {
        return { backgroundColor: '#99c6e8' }
      }
      return ''
    },
    // 学习进度
    getPercent(molecule, denominator) {
      function showText(val) {
        if (typeof val !== 'number') return '--'
        return formatSeconds(val)
      }
      const val = `${showText(molecule)} / ${showText(denominator)}`
      return val
    },
    questionListMap(type) {
      return (
        _.find(this.questionList, (item) => {
          return item.code === type
        })?.displayName || ''
      )
    },
    // 返回
    async goback() {
      if (this.$route.query.isNeedReplaceRoute == '1') {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== '/educational-training-management-sm/train-manage/train-task'
            })
          )
        }
        this.$router.go(-2)
      } else {
        // 兼容低代码
        const url = Wiz?.globalSettings?.globalConfig?.routerBase
          ? `/${Wiz.globalSettings.globalConfig.routerBase}/educational-training-management-sm/train-manage/train-task`
          : '/educational-training-management-sm/train-manage/train-task'
        this.$router.push(url)
      }
    },
    // 切换课件
    async changeCourse(row) {
      if (row.status === 0) {
        this.$message.warning('无法切换到未学习的课件。。。')
        return
      }
      if (row.id === this.currentCourse.trainingPersonCoursewareId || this.videoLoading) {
        this.$message.warning('加载中。。。')
        return
      }
      this.videoLoading = true
      this.saveTimer && clearInterval(this.saveTimer)
      const [err, res] = await trainingTaskApi.getCourseware({ id: row.id })
      if (err) return
      this.currentCourse = res.studying
      this.initVideoData(res.studying.fileId)
    },
    // 下一个问题
    goNextProblem() {
      if (this.problemIndex < this.currentProblemList.length - 1) {
        this.problemIndex = this.problemIndex + 1
        this.problem = this.currentProblemList[this.problemIndex]
      } else {
        this.problemIndex = 0
        this.isVideoShow = true
        this.$refs.videoRef.player.play()
      }
    },
    // 上一课程
    async getPreCourse() {
      this.videoLoading = true
      this.$refs.videoRef.player.pause()
      this.saveTimer && clearInterval(this.saveTimer)
      this.savePresscess()
      const params = {
        trainingPersonCoursewareId: this.currentCourse.trainingPersonCoursewareId,
        coursewareMaterialId: this.currentCourse.coursewareMaterialId,
      }
      const [err, res] = await trainingTaskApi.getPrev(params)
      if (err) return
      if (Object.keys(res).length) {
        this.currentCourse = res
        this.initVideoData(res.fileId)
      }
    },
    // 下一课程
    async getNextCourse() {
      this.videoLoading = true
      this.$refs.videoRef.player.pause()
      this.saveTimer && clearInterval(this.saveTimer)
      const params = {
        trainingPersonCoursewareId: this.currentCourse.trainingPersonCoursewareId,
        coursewareMaterialId: this.currentCourse.coursewareMaterialId,
        studyTimes:
          this.videoLastTime > this.currentCourse.times
            ? this.currentCourse.times
            : this.videoLastTime,
      }
      const [err, res] = await trainingTaskApi.getNext(params)
      if (err) return
      if (Object.keys(res).length) {
        this.currentCourse = res
        this.initVideoData(res.fileId)
      }
    },
    // 开始培训
    async initData() {
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      const { sub } = userInfo?.profile || { sub: '' }
      let isFirst = false
      this.videoLoading = true
      const hasTrainData = sessionStorage.getItem('HAS_TRAIN-COURSE')
      this.qualified = this.$route.query.status === '2'
      if (!hasTrainData && this.$route.query.status === '0') {
        isFirst = true
        sessionStorage.setItem(
          'HAS_TRAIN-COURSE',
          JSON.stringify([`${this.$route.query.id}${sub}`])
        )
      } else if (hasTrainData && this.$route.query.status === '0') {
        const arr = JSON.parse(hasTrainData)
        if (!arr.includes(`${this.$route.query.id}${sub}`)) {
          isFirst = true
          arr.push(`${this.$route.query.id}${sub}`)
          sessionStorage.setItem('HAS_TRAIN-COURSE', JSON.stringify(arr))
        }
      }

      const [err, res] = await trainingTaskApi[isFirst ? 'studying' : 'callContinue']({
        id: this.$route.query.id,
      })
      if (err) return
      this.currentCourse = res.studying
      this.tableList = res.coursewares
      this.sourceData = res
      this.initVideoData(res.studying.fileId)
    },
    // 视频初始化
    async initVideoData(id) {
      // const [err, res] = await fileApi.download(id)
      this.isVideoShow = true
      this.videoLoading = false
      const videoUrl = `${this.fileUrl}${id}/play-video`
      // if (err) return
      // const blob = new Blob([res])
      // const videoUrl = URL.createObjectURL(blob)

      if (this.options.sources.length) {
        this.options.sources[0].src = videoUrl
      } else {
        this.options.sources.push({ src: videoUrl, type: 'video/mp4' })
      }
    },
    pauseHandle(player) {},
    // 视频加载完开始同步数据
    async loadHandle(player) {
      player.play()
      const self = this
      this.saveTimer && clearInterval(this.saveTimer)
      this.videoLastTime = this.currentCourse.studyTimes
      if (this.currentCourse.studyTimes === this.currentCourse.times) {
        return
      }
      player.currentTime(this.videoLastTime)
      const params = {
        id: this.currentCourse.id,
        studyTimes: this.videoLastTime,
        questionId: null,
      }
      const [err, res] = await trainingTaskApi.close({ body: params })
      if (!err) {
        // 刷新页面展示进度
        this.showProcess(res)
      }
      this.saveTimer = setInterval(() => {
        self.savePresscess()
      }, 1000 * 60)
    },
    // 播放过程
    timeHandle(player) {
      // 是否快进
      if (player.currentTime() - 2 > this.videoLastTime) {
        player.currentTime(this.videoLastTime)
        return
      }

      this.videoLastTime =
        player.currentTime() > this.videoLastTime
          ? Math.floor(player.currentTime())
          : this.videoLastTime
      this.currentCourse.nodes.forEach((item) => {
        if (item.nodeTime === Math.floor(player.currentTime())) {
          this.$refs.videoRef.player.pause()
          this.currentProblemList = item.questions
          if (this.currentProblemList.length) {
            this.isVideoShow = false
            this.problem = this.currentProblemList[0]
            player.currentTime(player.currentTime() + 1)
          }
        }
      })
    },
    // 设置当前时间
    setCurrentTime() {
      const currentTime = Math.floor(this.$refs.videoRef.player.currentTime())
      this.$refs.videoRef.player.pause()
      return currentTime
    },
    // 循环播放
    endHandle() {
      this.savePresscess()
      this.saveTimer && clearInterval(this.saveTimer)
    },
    // 更新进度
    showProcess(data) {
      this.tableList = data.coursewares
      Object.keys(data).forEach((key) => {
        this.sourceData[key] = data[key]
      })
    },
    // 保存进度
    async savePresscess() {
      // 已完成当前视频培训
      if (
        this.IsDoneCompelete ||
        this.videoLastTime === 0 ||
        this.currentCourse.studyTimes === this.currentCourse.times
      ) {
        return
      }

      const params = {
        id: this.currentCourse.id,
        studyTimes:
          this.videoLastTime > this.currentCourse.times
            ? this.currentCourse.times
            : this.videoLastTime,
        questionId: null,
      }
      const [err, res] = await trainingTaskApi.close({ body: params })
      if (err) return
      // 刷新页面展示进度
      this.showProcess(res)
      // 完成培训要求
      if (res.status === 2 && !this.qualified) {
        this.qualified = true
        this.$message.success('恭喜您通过培训')
      }
      // 培训完当前视频-进行下一个视频
      if (this.videoLastTime >= this.currentCourse.times && this.currentCourse.hasNext) {
        this.getNextCourse()
        return
      }
      // 完成全部培训
      if (!this.currentCourse.hasNext && this.videoLastTime === this.currentCourse.times) {
        this.$confirm('恭喜您完成全部培训', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success',
          callback: async (action) => {
            this.IsDoneCompelete = true
            this.saveTimer && clearInterval(this.saveTimer)
            this.goback()
          },
        })
      }
    },
  },
  mounted() {
    this.initData()
  },
  beforeRouteLeave(to, from, next) {
    this.saveTimer && clearInterval(this.saveTimer)
    this.savePresscess()
    next()
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../../node_modules/vue-video-player/src/custom-theme.css';
@import '../../../../../node_modules/video.js/dist/video-js.css';
::v-deep .el-card__body {
  height: 100%;
}
.status-text {
  width: 80px;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  text-align: center;
  color: #fff;
}
</style>
